export interface CipRequestInterface {
  uploadedFilename: string;
  ssn_private: string;
  s24Status: string;
  confirmationNumber: string;
  sendToAWD: boolean;
  accountNumber: string;
  accountId: string;
}
